import { Button, Cascader, CloseCircleFilled, Divider, Tooltip } from 'gokwik-ui-kit'
import React, { useState } from 'react'

const FilterComponent = ({
    parameters,
    setParameters,
    filtersData,
    setFiltersData,
    getAllGASegmentData,
    setSelectedFilterList,
    activeTabKey,
}) => {
    const [openDropDown, setOpenDropDown] = useState(false)
    const [selectedFilters, setSelectedFilters] = useState(null)

    const optionsList = filtersData
        ?.map((filter, idx) => {
            const selectedValues =
                selectedFilters?.filter((selected) => selected[0] === filter.key).map((selected) => selected[1]) || []
            const unselectedValues = filter?.values?.filter((item) => !selectedValues.includes(item)) || []

            if (selectedValues.length === 0 && unselectedValues.length === 0) {
                return null // Return null if there are no children
            }

            return {
                value: filter?.key,
                label: (
                    <div
                        className='w-full max-w-48 whitespace-nowrap overflow-hidden text-ellipsis'
                        title={filter?.label}
                    >
                        <span className='p-2'>{filter?.label}</span>
                    </div>
                ),
                children: [
                    ...selectedValues.map((item) => ({
                        value: item,
                        label: (
                            <Tooltip title={item}>
                                <div className='w-full max-w-48 whitespace-nowrap overflow-hidden text-ellipsis'>
                                    <span className='p-2'>{item}</span>
                                </div>
                            </Tooltip>
                        ),
                    })),
                    ...unselectedValues.map((item) => ({
                        value: item,
                        label: (
                            <Tooltip title={item}>
                                <div className='w-full max-w-48 whitespace-nowrap overflow-hidden text-ellipsis'>
                                    <span className='p-2'>{item}</span>
                                </div>
                            </Tooltip>
                        ),
                    })),
                ],
            }
        })
        .filter((option) => option !== null)

    const transformData = (data) => {
        const transformed = data.reduce((acc, [key, value]) => {
            if (!acc[key]) {
                acc[key] = []
            }
            acc[key].push(value)
            return acc
        }, {})
        return transformed
    }

    const handleDataUpdate = (data) => {
        const transformedData = transformData(data)

        const transformedArray = Object.entries(transformedData).map(([key, values]) => ({
            key,
            values,
        }))
        setSelectedFilterList(transformedArray)
        getAllGASegmentData(transformedArray, 'apply_filters_cta')
    }

    const onChange = (value) => {
        setSelectedFilters(value)
    }

    const applyFilters = () => {
        handleDataUpdate(selectedFilters)
        setOpenDropDown(false)
    }

    const dropdownRender = (menus: React.ReactNode) => (
        <div>
            {menus}
            <Divider className='m-0' />
            <div className='p-2 flex justify-end'>
                <Button variant='primary' onClick={applyFilters}>
                    Apply Filters
                </Button>
            </div>
        </div>
    )

    const filter = (inputValue?, path?) =>
        path.some((option) => {
            const labelText = option?.value
            return labelText?.toLowerCase()?.indexOf(inputValue?.toLowerCase()) > -1
        })

    const handleClearFilters = () => {
        setSelectedFilterList([])
        setSelectedFilters(null)
        setParameters((prevParams) => {
            const newParams = {
                ...prevParams,
                page: 1,
            }

            return newParams
        })
    }

    return (
        <Cascader
            key={activeTabKey}
            onClear={handleClearFilters}
            showSearch={{ filter }}
            className='w-60'
            options={optionsList}
            onChange={onChange}
            multiple
            maxTagCount='responsive'
            placeholder={'Filter By'}
            dropdownRender={dropdownRender}
            open={openDropDown}
            onDropdownVisibleChange={(visible) => setOpenDropDown(visible)}
        />
    )
}

export default FilterComponent
